import MediaMonitorHelper from "../MediaMonitor/MediaMonitorHelper";
import { markerTypesNames } from "../TradingView/markerTypes";
import { getIsWeb } from "../platformHelper";
import {
  PLAN_PERMISSIONS_NAMES,
  PLAN_PERMISSIONS_SECTIONS
} from "../../redux/modules/auth/userPermissions/selector";

function openExternalLink(link) {
  if (getIsWeb()) {
    window.open(link, "_blank");
    return;
  }

  try {
    const { Linking } = require("react-native");
    Linking.openURL(link).catch(() => {});
  } catch (error) {
    // ignore
  }
}

/**
 * Host-side onMarkClick routing (parity with legacy TVChart).
 */
export default function buildTvChartBridgeMarkClickHandler({
  showModal,
  hasPermission,
  translate,
  getUserData
}) {
  return function handleMarkClick(payload = {}) {
    const { type, markerMetaData } = payload;
    const userData = typeof getUserData === "function" ? getUserData() : null;
    const { userIsNotLoggedIn } = userData ?? {};

    if (type === markerTypesNames.aggregatedMediaMonitorMessages) {
      showModal("AggregatedMarkersModal", {
        aggregatedMarkers: markerMetaData,
        userAccessOverride: hasPermission([
          PLAN_PERMISSIONS_NAMES.TRADING_VIEW_CHART
        ])
      });
      return;
    }

    if (type !== markerTypesNames.mediaMonitorMessages) {
      return;
    }

    const {
      title,
      description,
      provider,
      attachments,
      is_premium,
      link
    } = markerMetaData || {};

    let userHasAccessToContent = true;

    if (is_premium) {
      userHasAccessToContent = hasPermission(
        PLAN_PERMISSIONS_SECTIONS.MEDIA_MONITOR
      );
    }

    if (userHasAccessToContent) {
      if (description) {
        const helper = new MediaMonitorHelper(
          description,
          provider,
          translate,
          attachments
        );
        showModal("InterestingStockDescription", {
          title,
          content: helper.formatMediaMonitorEntry()
        });
        return;
      }

      if (link) {
        openExternalLink(link);
      }
      return;
    }

    if (userIsNotLoggedIn) {
      showModal("RegisterModal");
      return;
    }

    showModal("PremiumModal", {
      skipShowIfAlreadyVisible: true,
      name: "open a media monitor entry from the chart level",
      permissions: [PLAN_PERMISSIONS_SECTIONS.MEDIA_MONITOR]
    });
  };
}
